import React from 'react';
import Icon from '@components/atoms/icon/icon';
import styles from './product-card-location-icon.module.scss';

const ProductCardLocationIcon: React.FC<{ isLocalCountry: boolean }> = ({ isLocalCountry }) =>
  isLocalCountry ? (
    <Icon
      className={styles.locationIcon}
      data-cy="productCard__text__location__icon"
      name="sustainable-leaf"
    />
  ) : (
    <Icon
      className={styles.locationIcon}
      name="pin-full"
      data-cy="productCard__text__location__icon"
    />
  );

export default ProductCardLocationIcon;
